import { render, staticRenderFns } from "./OwarmStats.vue?vue&type=template&id=1b1097b1&scoped=true&"
import script from "./OwarmStats.vue?vue&type=script&lang=js&"
export * from "./OwarmStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1097b1",
  null
  
)

export default component.exports